import { HTTPClient } from '../utils/request'

// eslint-disable-next-line no-undef
const baseURL = process.env.VUE_APP_GMOV_TRACKING_URL

export default {
  table: ({ query = `` }) => HTTPClient.get(query, { baseURL }),
  get: ({ params = {}, query = '' }) =>
    HTTPClient.get(`/incident/travel/${params._id}${query}`, { baseURL }),
  track: ({ query = '' }) => HTTPClient.get(`/tracking${query}`, { baseURL }),
  route: ({ params }) => HTTPClient.get(`/route/${params._id}`, { baseURL }),
  trackingEvents: ({ params }) =>
    HTTPClient.get(`/tracking/trackingEvents/${params._id}`, { baseURL }),
  routeNotes: ({ params, payload }) =>
    HTTPClient.post(`/route/offer/${params._id}`, payload, { baseURL }),
  eventNotes: ({ params, payload }) =>
    HTTPClient.post(`/route/${params._id}`, payload, { baseURL }),
  dashboard: ({ params, query = '' }) =>
    HTTPClient.get(`/dashboard/${params.type}${query}`, { baseURL }),
  getFences: ({ query = '' }) => HTTPClient.get(`/fence${query}`, { baseURL }),
  addFence: ({ payload }) => HTTPClient.post(`/fence`, payload, { baseURL }),
  updateFence: ({ payload, params }) =>
    HTTPClient.put(`/fence/${params._id}`, payload, { baseURL }),
  routeFences: ({ params }) =>
    HTTPClient.get(`/fence/route/${params._id}`, { baseURL }),
  configs: ({ query = '' }) => HTTPClient.get(`/configs${query}`, { baseURL }),
  newConfig: ({ payload }) => HTTPClient.post(`/configs`, payload, { baseURL }),
  editConfig: ({ params, payload }) =>
    HTTPClient.put(`/configs/${params._id}`, payload, { baseURL }),
  commands: ({ params }) =>
    HTTPClient.get(`/external/${params.type}`, { baseURL }),
  command: ({ params, payload }) =>
    HTTPClient.post(`/external/${params.type}`, payload, { baseURL }),
  newDashboard: ({ query = '' }) =>
    HTTPClient.get(`/dashboard/${query}`, { baseURL }),
  listFences: ({ query, payload }) =>
    HTTPClient.post(`/intersections/${query}`, payload, { baseURL })
}
